import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { compose, withProps } from 'recompose';

import { actions as upcomingSurveyActions } from '../../redux/surveys/upcoming-survey';
import { preVisitConsentsModalActions } from '../../redux/healthboard/appointment-survey-assignment';
import { actions as upcomingSurveyProceedActions } from '../../redux/surveys/upcoming-survey-proceed';
import { actions as upcomingSurveyAnswersActions } from '../../redux/surveys/upcoming-survey-answers';
import { actions as upcomingSurveyCompletionsActions } from '../../redux/surveys/upcoming-survey-completions';
import { actions as upcomingSurveyCancelFillingActions } from '../../redux/surveys/upcoming-survey-cancel-filling';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../redux/context/selectors';
import {
  selectUpcomingSurvey,
  selectUpcomingSurveyProceedRejected,
  sendingUpcomingSurveyCompletionsSucceed,
} from '../../redux/surveys/selectors';

import styles from './index.styl';

const mapStateToProps = (state, { targetUserId }) => ({
  currentSurvey: selectUpcomingSurvey(state),
  isUpcomingSurveyRejected: selectUpcomingSurveyProceedRejected(state),
  isSendingUpcomingSurveyCompletionsSucceed: sendingUpcomingSurveyCompletionsSucceed(
    state,
  ),
  targetUserId:
    targetUserId || targetUserIdSelector(state) || loggedUserIdSelector(state),
});

const mapDispatchToProps = {
  clearUpcomingSurvey: upcomingSurveyActions.clear,
  clearSurveys: preVisitConsentsModalActions.setSurveys,
  sendUpcomingSurveyProceed: upcomingSurveyProceedActions.send,
  sendUpcomingSurveyAnswers: upcomingSurveyAnswersActions.send,
  clearUpcomingSurveyProceed: upcomingSurveyProceedActions.clear,
  clearUpcomingSurveyCompletions: upcomingSurveyCompletionsActions.clear,
  sendUpcomingSurveyCancelFilling: upcomingSurveyCancelFillingActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      clearSurveys,
      clearUpcomingSurvey,
      intl: { formatMessage },
      clearUpcomingSurveyProceed,
    }) => ({
      formatMessage,
      clearData: () => {
        clearSurveys([]);
        clearUpcomingSurvey();
        clearUpcomingSurveyProceed();
      },
    }),
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/SurveysPopup/enhance.js